import CaseInfo from './CaseInfo'

export default CaseInfo